/**
 * navigation.js — Mobile nav drawer + header scroll behavior.
 */

(function () {
  'use strict';

  // ─── Mobile nav drawer ────────────────────────────────────────────────────

  const drawer = document.getElementById('mobile-nav-drawer');
  const toggleBtns = document.querySelectorAll('[data-nav-toggle]');
  const closeTriggers = document.querySelectorAll('[data-nav-close]');

  function openNav() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-locked');
    toggleBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
  }

  function closeNav() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('scroll-locked');
    toggleBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
  }

  toggleBtns.forEach((btn) => btn.addEventListener('click', () => {
    const isOpen = drawer?.classList.contains('is-open');
    isOpen ? closeNav() : openNav();
  }));

  closeTriggers.forEach((el) => {
    // Only wire close triggers inside the drawer
    if (drawer && drawer.contains(el)) {
      el.addEventListener('click', closeNav);
    }
  });

  // Backdrop click
  drawer?.querySelector('.nav-drawer__backdrop')
    ?.addEventListener('click', closeNav);

  // Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeNav();
  });

  // ─── Header: scroll behavior ─────────────────────────────────────────────

  const header = document.getElementById('site-header');
  if (!header) return;

  let lastScroll = 0;
  let ticking = false;

  function onScroll() {
    const currentScroll = window.scrollY;

    // Add shadow when scrolled
    header.classList.toggle('is-scrolled', currentScroll > 10);

    lastScroll = currentScroll;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
})();
